export const ALPHANUMERIC_AND_DASHES_REGEX = /[^a-zA-Z0-9-]/g;
